import { render } from "./IconCheck.vue?vue&type=template&id=4c24df4c"
import script from "./IconCheck.vue?vue&type=script&lang=js"
export * from "./IconCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconCheck.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c24df4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c24df4c', __exports__)) {
    api.reload('4c24df4c', __exports__)
  }
  
  module.hot.accept("./IconCheck.vue?vue&type=template&id=4c24df4c", () => {
    api.rerender('4c24df4c', render)
  })

}


export default __exports__